export default "__VITE_ASSET__CCXtdTUj__"